module.exports = require("@swa-ui/vacations/src/VacationsRecentSearch/VacationsRecentSearch.module.scss");